// extracted by mini-css-extract-plugin
export default {"categoryText":"categoryNode_categoryText__x32xZ","active":"categoryNode_active__QcjvF","inactive":"categoryNode_inactive__ZVVXp"};